<template>
  <v-layout row>
    <v-flex xs12>
      <v-card class="pa-2 pb-4" flat>
        <v-card-title primary class="title">
          Логотипы объектов оргструктуры
        </v-card-title>
        <div class="mr-5" :class="{hideInherit:hideInherit}">
          <v-switch label="Скрыть наследуемые логотипы"
            v-model="hideInherit"
            color="info"
            hide-details></v-switch>
          <dantser-tree
            ref="logosTree"
            :source="logoTree"
            :table="tableConfig"
            @ctx-menu-td="openCtxMenu($event)"
          ></dantser-tree>
        </div>
      </v-card>
    </v-flex>

    <v-dialog v-model="dialog" max-width="600px" persistent>
      <logo-form 
        v-if="dialog && logoCopy!=null"
        :logo="logoCopy" 
        :element="nodeTemp.id" 
        :dialog="dialog" 
        :editMode="editMode" 
        @close-dialog="dialog=false"
        @logo-saved="saveLogo($event, false)"
      />
    </v-dialog>
    
    <context-menu id="logos-context-menu" ref="ctxMenu">
      <li @click="openLogoForm" v-if="accesses.logo_update"><v-icon small>mdi-pencil</v-icon> Редактировать</li>
      <li @click="onDeleteLogo" v-if="accesses.logo_delete && nodeTemp!=null && nodeTemp.parent_id!=='c_' && nodeTemp.logo.inherited===false">
        <v-icon small>mdi-delete</v-icon> Удалить
      </li>
    </context-menu>

  </v-layout>
</template>

<script>
  import contextMenu from 'vue-context-menu'
  import LogoForm from './LogoForm'
  import LogoItem from './LogoItem'
  import LogoButtons from './LogoButtons'
  import {mapGetters} from 'vuex'
  
  export default {
    name: 'Logo',

    components:{
      'logo-form': LogoForm,
      'logo-item': LogoItem,
      'logo-buttons': LogoButtons,
      'context-menu' : contextMenu,
    },

    data(){
      return {
        hideInherit: false,
        editMode: false,
        formLogo: {},
        logoCopy: null,
        nodeTemp: null,
        dialog: false,
        tableConfig:{
          className:'logo-table',
          indentation: 20,
          columns: [
            {type:'component', component:LogoItem},
            {type:'component', component:LogoButtons},
          ]
        },
      }
    },
  
    computed:{
      ...mapGetters('orgstructure', ['logoTree']),
      accesses(){
        return this.$store.state.app.account.accesses['orgstructure'] || {}
      }
    },

    beforeDestroy() {
      //Удаление обработчиков
      this.$bus.$off('logo.button')
    },
    
    created(){
      this.$bus.$on('logo.button', this.onButtonClick)
      
      if(!this.accesses.logo_access){
        this.$store.commit(`app/layout/setRouteStatus`, 'accessDenied')
      }
      this.getLogosTree()
    },

    methods:{
      onButtonClick(eventData){
        this.nodeTemp = eventData.data
        this.logoCopy = {...eventData.data.logo}
        
        if(eventData.type==='edit'){
          this.openLogoForm()
        } else if(eventData.type==='delete'){
          this.onDeleteLogo()
        }
      },
      
      getLogosTree(){
        this.$store.dispatch('orgstructure/getLogoTree')
      },

      openCtxMenu(eventData){
        if(eventData.cell===1 && (this.accesses.logo_update || this.accesses.logo_delete) ){
          //Две переменные нужны, потому что при вложенности возвращаются ссылки (data.logo будет ссылкой)
          this.nodeTemp = eventData.data
          this.logoCopy = {...eventData.data.logo}
          this.$refs.ctxMenu.open()
        }
      },
  
      onDeleteLogo(){
        this.$store.dispatch('orgstructure/deleteLogo', this.logoCopy.id).then( response => {
          let logo = this.$refs['logosTree'].getNodeById(this.nodeTemp.parent_id).logo
          let tempLogo = JSON.parse( JSON.stringify( logo ) )
          this.saveLogo(tempLogo, true)
        })
      },
      
      openLogoForm(){
        let type = this.logoCopy.image_url!=null ? 'image' : 'text'
        this.$set( this.logoCopy, 'type', type )
        this.editMode = ( this.logoCopy!=null && !this.logoCopy.inherited)
        this.dialog = true
      },

      saveLogo(eventData, inherit){
        let tempLogo = {...eventData}
        tempLogo.inherited = true
        eventData.inherited = inherit

        if (this.nodeTemp.children){
          let node
          let stack = [...this.nodeTemp.children]
          let idx = 0
          while (node = stack[idx++]) {
            if (node.logo.inherited === true) {
              node.logo = tempLogo
              let children = node.children || []
              for (let i = 0, len = children.length; i < len; i++) {
                stack.push(children[i]);
              }
            }
          }
        }
        this.nodeTemp.logo = eventData
        this.logoCopy = null
        this.dialog = false

        this.$store.commit('orgstructure/setlogoTree', this.logoTree)
        // Update app logo
        this.$store.dispatch('app/account/loadLogo')
      }
    }
  }
</script>

<style>
  table.logo-table tbody tr td{
    vertical-align: middle;
  }
  table.logo-table tbody tr td:first-child{
    width: 500px;
  }
  .dantsertree-ext-table.logo-table tbody tr td:nth-child(2){
    width: 240px;
    height: 81px !important;
    vertical-align: middle;
    text-align: center;
  }
  #logos-context-menu ul.ctx-menu li{
    padding: 5px 7px 5px 10px;
    cursor: pointer;
    font-size: 1rem;
  }
  #logos-context-menu ul.ctx-menu li:hover{
    background: #e4e4e4;
  }
  #logos-context-menu ul.ctx-menu li i{
    width: 20px;
  }
  .inherited{
    opacity: 0.5;
  }
  .hideInherit .inherited{
    display: none;
  }
</style>


// WEBPACK FOOTER //
// src/apps/org/components/Logo/Logo.vue